<template>
  <nav class="lang" v-if="fiurl && enurl">
    <a :href="fiurl" :class="{ active: lang === 'fi' }">FI</a>
    <a :href="enurl" :class="{ active: lang === 'en' }">EN</a>
  </nav>
</template>

<script setup>
import { useStore } from '@/KQL.js'

const kql = useStore()
const lang = document.documentElement.lang || 'fi'
const fiurl = computed(() => kql.page?.fiurl)
const enurl = computed(() => kql.page?.enurl)
</script>

<style scoped>
nav.lang {
  display: flex;
  gap: 1rem;
  align-items: center;
  font-size: 1rem;
  letter-spacing: 0.08em;
  text-transform: uppercase;
}

a { opacity: 0.4; transition: opacity 200ms; }
a:hover { opacity: 0.7; }
a.active { opacity: 1; }
</style>
